import React from "react";
import styles from "../styles";
import lobt from "../assets/lobt.png";

import git from "../assets/git.png";
import magicfresh from "../assets/magicfresh.png";
import huddle from "../assets/huddle.png";
import bloxchange from "../assets/bloxchange.png";

const Projects = () => {
  return (
    <section
      id="projects"
      className={`flex text-white gradient-05 ${styles.paddingX} ${styles.paddingY} w-full`}
    >
      <div className="flex flex-col justify-between gap-10 items-center">
        <h1 className="text-[40px] text-center font-semibold text-gradient">
          Freelancing Projects
        </h1>

        <div
          className={`flex flex-col justify-between items-center gap-20 ${styles.paddingY}`}
        >
          <div className="flex flex-col sm:flex-row w-full">
            <img
              src={lobt}
              alt="lobt"
              className="sm:w-1/2 rounded-2xl transition ease-in-out hover:scale-110 duration-300 cursor-pointer"
            />
            <div className="flex flex-col items-center sm:w-1/2 gap-4">
              <h1 className="text-[30px] text-[#B96FE2] xs:mt-4 font-semibold">
                LOBT
              </h1>
              <p className="text-[18px] text-slate-400 lg:text-start xs:text-center sm:w-[80%]">
                Developed a responsive and visually appealing website for a
                truck company using React and Tailwind CSS, implementing Home
                page, Contact Page, etc., resulting in a satisfied client and
                positive feedback.
                <br />
                Tech stack: ReactJS(vite), Tailwind CSS, Flowbite
              </p>
              <div className="flex flex-row gap-4">
                <a href="https://lobt.vercel.app/" target="_blank">
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[40px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    Have a look
                  </button>
                </a>
                {/* <a
                  href="https://github.com/dhrumishah/Legacy-Of-Brothers-Transportation"
                  target="_blank"
                >
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[40px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    <img src={git} className="w-[25px] absolute ml-6" />
                    <h1 className="ml-2 text-center">CODE</h1>
                  </button>
                </a> */}
              </div>
            </div>
          </div>
          {/* <div className="flex flex-col-reverse sm:flex-row w-full">
            <div className="flex flex-col items-center sm:w-1/2 gap-4">
              <h1 className="text-[40px] xs:text-[50px] font-semibold">
                GPT-3
              </h1>
              <p className="text-[24px] text-center sm:w-[80%]">
                GPT-3 is a Modern UI/UX Website. Made with ReactJS and
                TailwindCSS.
              </p>
              <div className="flex flex-row gap-4">
                <a href="https://chat-gpt-3-web.vercel.app/" target="_blank">
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[60px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    DEMO
                  </button>
                </a>
                <a
                  href="https://github.com/yashj069/ChatGPT3Web"
                  target="_blank"
                >
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[60px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    <img src={git} className="w-[25px] absolute ml-6" />
                    <h1 className="ml-2 text-center">CODE</h1>
                  </button>
                </a>
              </div>
            </div>
            <img
              src={gpt3}
              alt="degen"
              className="sm:w-1/2 rounded-2xl transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer"
            />
          </div> */}
          <div className="flex flex-col-reverse sm:flex-row w-full">
            <div className="flex flex-col items-center sm:w-1/2 gap-4 py-0 sm:py-10">
              <h1 className="text-[30px] text-[#B96FE2] text-center xs:mt-4 font-semibold">
                Magic Fresh Cleaning
              </h1>
              <p className="text-[18px] text-slate-400 lg:text-start xs:text-center sm:w-[80%]">
                Revamped a website using NextJS and Styled Components that let
                anyone book an appointment to clean their homes.
                <br />
                Tech stack: NextJs, Styled components, Stripe Payments API
              </p>
              <div className="flex flex-row gap-4">
                <a href="https://www.magicfresh.cleaning/" target="_blank">
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[40px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    Have a look
                  </button>
                </a>
              </div>
            </div>

            <img
              src={magicfresh}
              alt="degen"
              className="sm:w-1/2 rounded-2xl transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer"
            />
          </div>
          <h1 className="text-[40px] text-center font-semibold text-gradient">
            Hackathon Projects
          </h1>

          <div className="flex flex-col sm:flex-row w-full">
            <img
              src={huddle}
              alt="degen"
              className="sm:w-1/2 rounded-2xl transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer bg"
            />
            <div className="flex flex-col items-center sm:w-1/2 gap-4">
              <h1 className="text-[30px] text-[#B96FE2] text-center xs:mt-4 font-semibold">
                medXhuddle
              </h1>
              <p className="text-[18px] text-slate-400 lg:text-start xs:text-center sm:w-[80%]">
                A decentralized web application that allows users to consult
                doctors online through a 1-on-1 video call. .Users need to pay
                the doctor’s consulting fees in MATIC. I worked on building the
                Frontend for the Dapp using React.js and TailwindCSS.
                <br />
                Tech stack: ReactJS(vite), Tailwind CSS, Solidity
              </p>
              <div className="flex flex-row gap-4">
                <a
                  href="https://github.com/dhrumishah/Huddle01-Hack"
                  target="_blank"
                >
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[40px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    <img src={git} className="w-[25px] absolute ml-6" />
                    <h1 className="ml-2 text-center">CODE</h1>
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col-reverse sm:flex-row w-full">
            <div className="flex flex-col items-center sm:w-1/2 gap-4">
              <h1 className="text-[30px] text-[#B96FE2] text-center xs:mt-4 font-semibold">
                bloXchange
              </h1>
              <p className="text-[18px] text-slate-400 lg:text-start xs:text-center sm:w-[80%]">
                A P2P marketplace which we built for the Chainlink hackathon. It
                lets users buy and sell their used products on top of the
                blockchain. Users can pay in MATIC for the products they buy and
                uses the Escrow Contract for the payment. I work on to build the
                frontend for the Dapp using ReactJS and Tailwind CSS.
                <br />
                Tech stack: ReactJS, Tailwind CSS, Solidity, Polygon
              </p>
              <div className="flex flex-row gap-4">
                <a
                  href="https://github.com/dhrumishah/bloXchange"
                  target="_blank"
                >
                  <button className="rounded-md transition border-white border-[2px] font-semibold hover:bg-white hover:text-black w-[150px] h-[40px] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300">
                    <img src={git} className="w-[25px] absolute ml-6" />
                    <h1 className="ml-2 text-center">CODE</h1>
                  </button>
                </a>
              </div>
            </div>
            <img
              src={bloxchange}
              alt="degen"
              className="sm:w-1/2 rounded-2xl transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300 cursor-pointer bg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
